
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'DiabeticFeet',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/DiabeticFeet.vue